import { createContext, useContext, useEffect, useMemo, useState } from "react"
import { isRefreshTokenValid, isTokenExpired } from "utility/Utils"

export const tokenRefreshedEventType = 'tokenRefreshed'

const TokenContext = createContext(null)

export const emitRefreshOrAccessTokenChangedEvent = () => {
  window.dispatchEvent(new Event(tokenRefreshedEventType))
}

export const TokenProvider = ({ children }) => {
  const [isAccessTokenExpired, setIsAccessTokenExpired] = useState(isTokenExpired())
  // para mostrar a tela de de token expirado, verificamos se o refresh token é inválido e se não está vazio,
  // se for invalido e estiver vazio significa que o usuário não está logado e deve ir para a tela de login
  const [shouldShowExpiredRefreshTokenScreen, setShouldShowExpiredRefreshTokenScreen] = useState(isTokenExpired() && isRefreshTokenValid())

  const updateTokenState = () => {
    setIsAccessTokenExpired(isTokenExpired())
    setShouldShowExpiredRefreshTokenScreen(isTokenExpired() && isRefreshTokenValid())
  }

  useEffect(() => {
    window.addEventListener(tokenRefreshedEventType, updateTokenState)

    return () => {
      window.removeEventListener(tokenRefreshedEventType, updateTokenState)
    }
  }, [])

  return (
    <TokenContext.Provider value={{ isAccessTokenExpired, shouldShowExpiredRefreshTokenScreen }}>
      {children}
    </TokenContext.Provider>
  )
}

export const useToken = () => {
  const context = useContext(TokenContext)

  if (!context) {
    throw new Error('useToken must be used within a TokenProvider')
  }

  return useMemo(() => ({
    isAccessTokenExpired: context.isAccessTokenExpired,
    isAccessTokenValid: !context.isAccessTokenExpired,
    shouldShowExpiredRefreshTokenScreen: context.shouldShowExpiredRefreshTokenScreen

  }), [context.isAccessTokenExpired])
}
